import { Component, computed, Directive, inject, input } from '@angular/core';
import { MteTextWrapper } from '@mortar/angular/elements/atomic/text';
import { MtrFormFieldModule } from '@mortar/angular/components/atomic/form-field';
import { DisplayComponent } from 'app/driver-pay/persistence/core/components/displays/DisplayComponent';
import { MtrOption } from '@mortar/angular/components/core';

@Directive({
  selector: '[enumContext]',
  standalone: true,
})
export class EnumContextDirective {
  options: MtrOption[] = [];
}

@Component({
  selector: 'enum-display',
  template: `
    @if (value() !== undefined) {
      <mte-text id="{{ this.id() ?? value() }}">{{ label() }}</mte-text>
    }
  `,
  standalone: true,
  imports: [MteTextWrapper, MtrFormFieldModule],
})
export class EnumDisplayComponent implements DisplayComponent {
  id = input<string>();
  value = input.required<any>();
  enumContext = inject(EnumContextDirective);

  label = computed(() => {
    const value = this.value();
    for (const option of this.enumContext.options) {
      if (value === option.value) {
        return option.label;
      }
    }
    return '<unknown>';
  });
}
